import React from "react";
import axios from "axios";
import { trans } from "@cortexglobal/rla-intl";
import { StyledSelectAsync } from "@cortexglobal/rla-components";

const GroupSelector = ({
    onChange,
    name = "user",
    value = [],
    multi = false,
    ...rest
}) => {
    const loadOptions = (search, loadedOptions, { page = 1 }) => {
        return axios
            .get(`/api/v1/group/options`, {
                params: { searchText: search, page },
            })
            .then(({ data }) => {
                const { current_page, last_page } = data.meta;
                return {
                    options: data.data.map((userOption) => {
                        return { ...userOption, label: userOption.text };
                    }),
                    hasMore: current_page < last_page,
                    additional: {
                        page: page + 1,
                    },
                };
            });
    };

    const onOptionChange = (value) => {
        if (multi) {
            onChange({ name, value: [value] });
        } else {
            onChange({ name, value: [value["value"]] });
        }
    };

    return (
        <StyledSelectAsync
            name={name}
            value={value}
            onChange={onOptionChange}
            placeholder={
                multi ? trans("Select Groups...") : trans("Select a Group...")
            }
            maxMenuHeight={150}
            loadOptions={loadOptions}
            additional={{ page: 1 }}
            multi={multi}
            {...rest}
        />
    );
};

export default GroupSelector;
